import { render, staticRenderFns } from "./LawAuthorityTypeList.vue?vue&type=template&id=1756d322&"
import script from "./LawAuthorityTypeList.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityTypeList.vue?vue&type=style&index=0&id=1756d322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports